export default __webpack_public_path__ + "00d650d72060e02e2c80e8ae0d4cf25d.png";